import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from "react-intl";

class JourneyType extends React.Component {

  render() {
    const {intl:{formatMessage}} = this.props;

    const {type} = this.props;
    return <span>{formatMessage({id:`intervention.type.${type}`})}</span>;
  }
}


export default injectIntl(JourneyType);

JourneyType.propTypes ={
  status: PropTypes.string
}




// WEBPACK FOOTER //
// ./src/components/common/format/JourneyType.js